import { Input, Card, Rate } from "antd";
import Table, { ColumnsType } from "antd/lib/table";

import { TableHelper } from "../../util/TableHelper";
import Loading from "../common/Loading";
import { useUserFeedback } from "./index.hook";
import CustomerLocationFilter from "../common/CustomerLocationFilter";
import styles from "./index.module.less";

import type { FeedbackRecordItem } from "../../shared/interface/UserFeedback.interface";

const UserFeedback = () => {
  const config = useUserFeedback();

  const columns: ColumnsType<FeedbackRecordItem> = [
    {
      align: "left",
      title: "Sr No.",
      dataIndex: "sr_no",
      key: "sr_no",
      render: TableHelper.renderNumberValue,
      sorter: {
        compare: TableHelper.valueCompare("sr_no")
      },
      width: "5%"
    },
    {
      align: "left",
      title: "Customer",
      dataIndex: "customer_name",
      key: "customer_name",
      render: TableHelper.renderText,
      sorter: {
        compare: TableHelper.valueCompare("customer_name")
      }
    },
    {
      align: "left",
      title: "Location",
      dataIndex: "location_name",
      key: "location_name",
      render: TableHelper.renderText,
      sorter: {
        compare: TableHelper.valueCompare("location_name")
      }
    },
    {
      align: "left",
      title: "User",
      dataIndex: "user",
      key: "user",
      render: (text) => <div dangerouslySetInnerHTML={{ __html: text }} />,
      sorter: {
        compare: TableHelper.valueCompare("user")
      }
    },
    {
      align: "left",
      title: "Feedback Date",
      dataIndex: "created_on",
      key: "created_on",
      render: TableHelper.renderNumberValue,
      sorter: {
        compare: TableHelper.valueCompare("created_on")
      }
    },
    {
      align: "left",
      title: "Feedback Content",
      dataIndex: "feedback",
      key: "feedback",
      render: TableHelper.renderTextContainer,
      sorter: {
        compare: TableHelper.valueCompare("feedback")
      }
    },
    {
      align: "left",
      title: "Rating",
      dataIndex: "rating",
      key: "rating",
      render: (rating: number) => <Rate disabled defaultValue={rating} />
    }
  ];

  return (
    <Card className="gx-card card--height" title={null}>
      <div className={styles["head-container"]}>
        <div className={styles["left-section"]}>
          <div className="card-title-style">User Feedback</div>
        </div>
        <div className={styles["right-section"]}>
          <CustomerLocationFilter selectedCustomerId={config.selectedCustomerId} selectedLocationId={config.selectedLocationId} handleChangeCustomer={config.handleChangeCustomer} handleChangeLocation={config.handleChangeLocation} />
          <Input.Search className={`gx-mb-0 search-component__width`} allowClear placeholder={`Search...`} value={config.searchedText} onChange={(e) => config.handleChangeSearch(e.target.value)} onSearch={config.handleChangeOnSearch} />
        </div>
      </div>

      {config.loading && <Loading />}

      {!config.loading && <Table className="gx-table-responsive gx-mt-4" size="small" columns={columns} dataSource={config.feedbackData} pagination={config?.pagination} bordered onChange={config.handleChangePagination} rowKey={(record) => record.sr_no} />}
    </Card>
  );
};
export default UserFeedback;
